import { CustomGridColumns } from '~/components/CustomDataGrid/protocols';
import { icmsColumns } from './Icms';
import { CbenefColunm } from './Cbenef';
import { identificadorColumns } from './Idenficador';
import { quantidadeColumns } from './Quantidade';
import { stColumns } from './St';
import { tributacaoColumns } from './Tributacao';
import { variaveisColumns } from './Variaveis';
import { ibsCbs } from './IbsCbs';

export const tableItensColumns: CustomGridColumns[] = [
  ...identificadorColumns,
  ...quantidadeColumns,
  ...variaveisColumns,
  ...icmsColumns,
  ...stColumns,
  ...CbenefColunm,
  ...tributacaoColumns,
  ...ibsCbs,
];
